import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "Amei bastante, estava com dificuldade em emagrecer, mas com as ajudas dos nutricionistas, mudei totalmente minha alimentação e a forma de fazer os exercícios.",
    name: 'VANESSA KRISTEN',
    status : 'EMPREENDEDORA'
  },
  {
    image: image2,
    review: 'Super atenciosos, quando tive dificuldade me deram total suporte, já indiquei a algumas amigas, SUPER INDICO.',
    name: 'CLARISSA SANTOS',
    status: 'TREINADORA'
  },
  {
    image : image3,
    review:'Até achei que não daria certo por sem uma forma online, mas foi ótimo, conseguir mudar a minha alimentação sempre me indicando quais nutrientes consumir, de qual forma e as quantidades adequadas. Sinto que agora estou mais perto em conseguir chegar em meu tão sonhado sonho em me tornar um fisiculturista.',
    name: 'FRANKLIN',
    status: "FISICUTURISTA"
  }
];
